<template>
  <router-view />
  <!-- Mostrar alertas de manera reactiva -->
  <v-snackbar
    v-model="alertStore.visible"
    :timeout="alertStore.timeout"
    :color="alertStore.type"
    location="bottom center"
    multi-line
  >
    {{ alertStore.message }}
    <template #actions>
      <v-btn icon @click="alertStore.closeAlert">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { useAuthStore } from "@/store/auth"; // Import the store
import { useAlertStore } from "@/store/alertStore"; // Importamos el store de alertas
import { setAuthToken } from "@/plugins/axios"; // Import the method to set the token in the axios headers
import { watch } from 'vue';

export default {
  name: 'App',
  async created() {
    const authStore = useAuthStore(); // Access the auth store

    // Check if a token exists in localStorage (already saved during login)
    if (authStore.token) {
      // Set the token in axios headers to include it in every API request
      setAuthToken(authStore.token); 
      
      try {
        // Initialize user by fetching their data using the stored token
        await authStore.initializeUser();
      } catch (error) {
        console.error("Failed to initialize user:", error);
      }
    }
  },
  setup() {
    const alertStore = useAlertStore();

    return {
      alertStore
    };
  }
};
</script>
